import React from 'react';

import StepWithDiagram from '../StepWithDiagram';

interface Props {}

const PaymentInitiationSetupFlow: React.FC<Props> = (props: Props) => (
  <>
    <StepWithDiagram
      step={1}
      asset='/assets/img/docs/payment_initiation/setup_flow/payment-setup-row-1.png'
    >
      Your app collects information of the sender and the recipient, as well as
      the payment amount.
    </StepWithDiagram>
    <StepWithDiagram
      step={2}
      asset='/assets/img/docs/payment_initiation/setup_flow/payment-setup-row-2.png'
    >
      With this information,{' '}
      <a href='/docs/api/products/payment-initiation/#payment_initiationrecipientcreate'>
        <b>create a recipient</b>
      </a>{' '}
      and obtain a <code>recipient_id</code>. You can reuse this{' '}
      <code>recipient_id</code> for future payments.
    </StepWithDiagram>
    <StepWithDiagram
      step={3}
      asset='/assets/img/docs/payment_initiation/setup_flow/payment-setup-row-3.png'
    >
      <a href='/docs/api/users/#usercreate'>
        <b>Create a user</b>
      </a>{' '}
      and obtain a <code>user_id</code>. You can reuse this <code>user_id</code>{' '}
      for future payments by the same sender.
    </StepWithDiagram>
    <StepWithDiagram
      step={4}
      asset='/assets/img/docs/payment_initiation/setup_flow/payment-setup-row-4.png'
    >
      Provide the <code>recipient_id</code> and <code>user_id</code> to Plaid
      when you{' '}
      <a href='/docs/api/products/payment-initiation/#payment_initiationpaymentcreate'>
        <b>create a payment</b>
      </a>
      . Store the resulting <code>payment_id</code> along with your payment
      metadata.
    </StepWithDiagram>
    <StepWithDiagram
      step={5}
      asset='/assets/img/docs/payment_initiation/setup_flow/payment-setup-row-5.png'
    >
      From your backend, use the <code>payment_id</code> and{' '}
      <code>user_id</code> to{' '}
      <a href='/docs/api/link/#linktokencreate'>
        <b>create a link_token</b>
      </a>
      .
    </StepWithDiagram>
    <StepWithDiagram
      step={6}
      asset='/assets/img/docs/payment_initiation/PIS-overview-row-2.png'
    >
      Your client app uses the <code>link_token</code> to initiate a Link flow
      for your user. The onSuccess callback signals that the payment has been
      initiated.
    </StepWithDiagram>
    <StepWithDiagram
      step={7}
      asset='/assets/img/docs/payment_initiation/setup_flow/payment-setup-row-6.png'
    >
      Your backend listens for{' '}
      <a href='/docs/api/products/payment-initiation#payment_status_update'>
        <code>PAYMENT_STATUS_UPDATE</code>
      </a>{' '}
      webhooks to keep track of the payment's status.
    </StepWithDiagram>
  </>
);

PaymentInitiationSetupFlow.displayName = 'PaymentInitiationSetupFlow';

export default PaymentInitiationSetupFlow;
